import api from "../../client";

export const deleteContentBoxRequest = async (
  id: string | undefined,
): Promise<void> => {
  const { data } = await api.delete(`/content-box/${id}`);

  return data;
};
